import { scrollToElement } from '~/components/utils/browser/ui';

export default {
  bind(el, binding) {
    const handler = () => {
      const parent = el.parentNode;
      const scrollTo = document.querySelector(binding.value);

      if (parent && scrollTo) {
        scrollToElement(parent, scrollTo);
      }
    };

    el.addEventListener('click', handler, { passive: true });
    el.$destroy = () => el.removeEventListener('click', handler, { passive: true });
  },
  unbind(el) {
    el.$destroy();
  },
};
